// Application Statuses
export const COMPLETED = 'completed';
export const DENIED = 'denied';
export const ON_HOLD = 'on hold';
export const PENDING_DECISION = 'pending decision';
export const REC_AWARD = 'rec. award';
export const FULL_REVIEW = 'full review';
export const CLOSED = 'closed';

export type ApplicationStatus =
	| typeof COMPLETED
	| typeof DENIED
	| typeof ON_HOLD
	| typeof PENDING_DECISION
	| typeof REC_AWARD
	| typeof FULL_REVIEW
	| typeof CLOSED;

// Input Placeholders
export const ONLY_DATE = 'mm/dd/yyyy';

export const SUPPORT_EMAIL = 'support.ecivis@eunasolutions.com';

// Account types nomenclature is the same on all environments:
export const DUSER_ACCOUNT_TYPE = 1;
export const DMAH_ACCOUNT_TYPE = 2;
export const OMAH_ACCOUNT_TYPE = 3;
export const CBO_ACCOUNT_TYPE = 4;
export const AUDITOR_ACCOUNT_TYPE = 5;
// Account types that can modify notification settings.
export const ALLOWED_ACCOUNT_TYPES_FOR_PROGRAM_NOTIFICATION_SETTINGS = [
	DUSER_ACCOUNT_TYPE,
	DMAH_ACCOUNT_TYPE,
	OMAH_ACCOUNT_TYPE,
	CBO_ACCOUNT_TYPE
];
export const ALLOWED_ACCOUNT_TYPES_FOR_ORG_NOTIFICATION_SETTINGS = [OMAH_ACCOUNT_TYPE];
